import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { postDebtSchedules } from './debt-schedules.service';

import { DebtScheduleDto } from '@/generated-types';

export const usePostDebtSchedule = (): ReturnType<
	typeof useMutation<void, AxiosError, DebtScheduleDto>
> => {
	const hash = sessionStorage.getItem('context') || '';

	return useMutation({
		mutationFn: (payload: DebtScheduleDto) => postDebtSchedules(payload, { hash }),
	});
};
